var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInductionCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "url(#paint0_linear_9363_40935)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9363_40935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0006 24.1699L13.5306 20.6999C13.1406 20.3099 12.5106 20.3099 12.1206 20.6999C11.7306 21.0899 11.7306 21.7199 12.1206 22.1099L16.3006 26.2899C16.6906 26.6799 17.3206 26.6799 17.7106 26.2899L28.2906 15.7099C28.6806 15.3199 28.6806 14.6899 28.2906 14.2999C27.9006 13.9099 27.2706 13.9099 26.8806 14.2999L17.0006 24.1699Z",
    fill: "url(#paint1_linear_9363_40935)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9363_40935",
    x1: 4.69543e-7,
    y1: 3.59998,
    x2: 40.651,
    y2: 4.34215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03CE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BC94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9363_40935",
    x1: 11.8281,
    y1: 15.1392,
    x2: 28.8514,
    y2: 15.5533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03CE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BC94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9363_40935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInductionCheck);
export default __webpack_public_path__ + "static/media/induction_check.fbaf858e992c7923eb01385dfacf9b22.svg";
export { ForwardRef as ReactComponent };